<template>
  <div class="TowerCrane">
    <el-carousel
      v-if="visi"
      :interval="element.style.interval"
      arrow="always"
      @change="change"
    >
      <el-carousel-item
        v-for="item in list"
        :key="item.ycjzDeviceId"
      >
        <div class="box">
          <div class="left">
            <div class="wrapping">
              <div class="txt">
                塔机名称
              </div>
              <div class="name">
                {{ item.craneName }}
              </div>
            </div>
            <div class="wrapping">
              <div class="txt">
                在线状态
              </div>
              <div
                class="name red"
                :class="{ green: item.deviceStatus == '1' }"
              >
                {{ item.deviceStatus == "1" ? "在线" : "离线" }}
              </div>
            </div>
            <div class="wrapping">
              <div class="txt">
                报警状态
              </div>
              <div
                class="name green"
                :class="{ red: item.alarmStatus == '1' }"
              >
                {{ item.alarmStatus == "1" ? "报警" : "正常" }}
              </div>
            </div>
          </div>
          <div class="img">
            <img
              src="../../../../../../../assets/images/custom-screen/tower.png"
              alt=""
            />
            <div class="desc">
              塔帽高：{{ item.towerCapHight }}米
            </div>
            <div class="desc1">
              尾臂长：{{ detail.backArmLength }}米
            </div>
            <div class="desc2">
              臂长：{{ detail.frontArmLength }}米
            </div>
            <div class="desc3">
              塔高：{{ item.towerHight }}米
            </div>
          </div>
          <div
            class="list"
            :style="`font-size: ${changeDevicePixelRatio(12)}px;`"
          >
            <div class="item">
              <div class="icon">
                <img
                  src="../../../../../../../assets/images/custom-screen/tower/1.png"
                  alt=""
                />
              </div>
              <div class="info">
                <div class="label">
                  高度
                </div>
                <div class="num">
                  {{ detail.height }}米
                </div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img
                  src="../../../../../../../assets/images/custom-screen/tower/2.png"
                  alt=""
                />
              </div>
              <div class="info">
                <div class="label">
                  倾角
                </div>
                <div class="num">
                  {{ detail.obliguity }}度
                </div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img
                  src="../../../../../../../assets/images/custom-screen/tower/3.png"
                  alt=""
                />
              </div>
              <div class="info">
                <div class="label">
                  力矩
                </div>
                <div class="num">
                  {{ detail.moment }}%
                </div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img
                  src="../../../../../../../assets/images/custom-screen/tower/4.png"
                  alt=""
                />
              </div>
              <div class="info">
                <div class="label">
                  幅度
                </div>
                <div class="num">
                  {{ detail.tcMlMaxScope }}米
                </div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img
                  src="../../../../../../../assets/images/custom-screen/tower/5.png"
                  alt=""
                />
              </div>
              <div class="info">
                <div class="label">
                  风速
                </div>
                <div class="num">
                  {{ detail.windSpeed }}米/秒
                </div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img
                  src="../../../../../../../assets/images/custom-screen/tower/6.png"
                  alt=""
                />
              </div>
              <div class="info">
                <div class="label">
                  载重
                </div>
                <div class="num">
                  {{ detail.weight }}吨
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { siteCraneDeviceList, siteCraneDeviceQueryDetail } from '@/api/device'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
export default {
  props: {
    propValue: {
      type: String,
      default: ''
    },
    areaIdList: {
      type: [String, Array],
      default: ''
    },
    element: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      list: [],
      index: 0,
      detail: {},
      visi: true
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem
    })
  },
  watch: {
    'element.style.interval': {
      deep: true,
      handler(val) {
        this.visi = false
        this.$nextTick(() => {
          this.visi = true
        })
      }
    }
  },
  created() {
    this.getData()
  },

  methods: {
    changeDevicePixelRatio,
    getData() {
      siteCraneDeviceList({
        projectId: this.projectItem.projectId,
        pageSize: 9999,
        pageNumber: 1
      }).then((res) => {
        this.list = res.data.records
        this.getDetail()
        // this.list = [{}]
      })
    },
    change(e) {
      this.index = e
      this.getDetail()
    },
    getDetail() {
      if (this.list[this.index]) {
        siteCraneDeviceQueryDetail({
          projectId: this.projectItem.projectId,
          id: this.list[this.index].craneDeviceId
        }).then((res) => {
          // Object.assign({})
          if (res.data.lastRealtime) {
            res.data.lastRealtime.tcMlMaxScope =
              res.data.siteCraneDevice.tcMlMaxScope
          }
          if (res.data.siteCraneDeviceParam) {
            res.data.lastRealtime.backArmLength =
              res.data.siteCraneDeviceParam.backArmLength
            res.data.lastRealtime.frontArmLength =
              res.data.siteCraneDeviceParam.frontArmLength
          }
          this.detail = res.data.lastRealtime || res.data.siteCraneDevice
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.TowerCrane {
  color: #fff;
  width: 100%;
  height: 100%;
  position: relative;
  .el-carousel {
    height: 100%;
  }
  .box {
    display: flex;
    color: #fff;
    height: 100%;
    padding-top: 3%;
    .left {
      height: 100%;
      width: 26%;
      .wrapping {
        background: #00468e;
        border-radius: 4px;
        width: 70%;
        margin: 0 auto;
        text-align: center;
        padding: 3% 0;
        margin-bottom: 5%;
        .txt {
          line-height: 1.3;
        }
        .name {
          line-height: 1.3;
        }
      }
    }
    .img {
      width: 50%;
      margin-left: 5%;
      position: relative;
      .desc {
        position: absolute;
        top: 0;
        left: 10%;
        transform: translate(0, -100%);
      }
      .desc1 {
        position: absolute;
        top: 4%;
        left: 0%;
      }
      .desc2 {
        position: absolute;
        top: 4%;
        right: 0%;
      }
      .desc3 {
        position: absolute;
        top: 50%;
        left: 0%;
      }
      img {
        width: 100%;
      }
    }
    .list {
      flex: 1;
      .item {
        display: flex;
        background: #00468e;
        width: 70%;
        margin: 0 auto;
        justify-content: space-between;
        padding: 8% 6%;
        margin-bottom: 4%;
        border-radius: 4px;
        .icon {
          img {
            width: 100%;
          }
        }
        .info {
          text-align: center;
          width: 55%;
          flex-shrink: 0;
          div {
            line-height: 1.1;
          }
        }
      }
    }
  }
}
</style>
<style>
.TowerCrane .el-carousel__container {
  height: 100%;
}
</style>
